import React from "react";
import { useLocation } from "react-router-dom";
import { Typography, Container, Box, Grid, Zoom } from "@mui/material";
import Footer from "../components/Footer";
import { db } from "../config/firebase/config";

export default function Skills(props) {
  const location = useLocation();
  const [skills, setSkills] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [startAnimation, setStartAnimation] = React.useState(false);

  const cargarImagen = (entrada, observador) => {
    entrada.forEach((x) => {
      if (x.isIntersecting) {
        document.getElementById("containerSkills").style.visibility = "visible";
        setStartAnimation(true);
      }
    });
  };

  React.useEffect(() => {
    db.collection("skills")
      .orderBy("order")
      .onSnapshot((data) => {
        setSkills(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })));
        setLoading(true);
      });
    if (loading) {
      if (document.getElementById("containerSkills")) {
        let containerSkills = document.getElementById("containerSkills");
        const observador = new IntersectionObserver(cargarImagen, { root: null, rootMargin: "0px", threshold: 0.1 });
        observador.observe(containerSkills);
      }
    }
  }, [loading]);

  return (
    <>
      <Container sx={{ pt: { xs: 10, sm: 12 }, pb: { xs: 10, sm: 12 }, minHeight: "100vh", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
        <Container disableGutters maxWidth="lg" id="containerSkills" style={{ visibility: "hidden" }}>
          {loading ? (
            <>
              <Zoom in={startAnimation} timeout={1000}>
                <Typography variant="h3" component="h2" textAlign="center" color="primary" className="tracking-in-expand" sx={{ pb: 10 }}>
                  SKILLS
                </Typography>
              </Zoom>

              <Grid container spacing={1} rowSpacing={10}>
                {skills.map((data, index) => (
                  <Zoom item key={data.id} in={startAnimation} timeout={1000} style={{ transitionDelay: (index + 1) * 700 }}>
                    <Grid item key={data.id} xs={4} sm={3} md={2}>
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          textAlign: "center",
                        }}
                      >
                        <div>
                          <img alt={data.name} title={data.name} src={data.img} width="70px" height="70px" />
                        </div>
                        <div>
                          <Typography>{data.name}</Typography>
                        </div>
                      </Box>
                    </Grid>
                  </Zoom>
                ))}
              </Grid>
            </>
          ) : null}
        </Container>
      </Container>
      {location.pathname === "/" || location.pathname === "/home" ? null : <Footer />}
    </>
  );
}
